<template>
  <div>
    <fieldset class="c-icon-list">
      <legend class="visually-hidden">{{ title }}</legend>
      <ul class="c-icon-list__group" role="radiogroup">
        <li
          class="c-icon-list__item"
          v-for="(item, index) in items"
          :key="index"
        >
          <input
            class="c-icon-list__input"
            @change="handleCheckBoxChange(item.title)"
            :name="title"
            type="radio"
            :id="`${name}-${index}`"
          />
          <label class="c-icon-list__label" :for="`${name}-${index}`">
            <span class="c-icon-list__icon" v-if="item.icon">
              <svg
                class="c-icon-list__icon-svg"
                aria-hidden="true"
                focusable="false"
              >
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  :xlink:href="`#${item.icon}`"
                ></use>
              </svg>
            </span>
            {{ item.title }}</label
          >
        </li>
      </ul>
    </fieldset>
    <div class="c-icon-list__actions">
      <button
        type="button"
        class="c-button c-button--brand c-icon-list__button"
        @click="setCurrentPanel()"
      >
        Back
      </button>
      <button
        type="button"
        class="c-button c-button--brand c-icon-list__button"
        @click="handleNextButton"
        :disabled="!selectedPanel"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      items: {
        required: true,
        type: Object,
      },
      title: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        selectedPanel: null,
      };
    },
    computed: {
      name() {
        return this.title.toLowerCase().replace(" ", "-");
      },
    },
    methods: {
      handleCheckBoxChange(checkedOption) {
        this.selectedPanel = checkedOption;
      },
      handleNextButton() {
        this.$emit("click", this.selectedPanel);
      },
      setCurrentPanel() {
        this.$emit("setCurrentPanel", this.title);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/contact-us/_vue/IconList.vue